export const SOLUTIONS_REQUEST = 'SOLUTIONS_REQUEST';
export const SOLUTIONS_SUCCESS = 'SOLUTIONS_SUCCESS';
export const SOLUTIONS_ERROR = 'SOLUTIONS_ERROR';

export const SOLUTIONS_ME_REQUEST = 'SOLUTIONS_ME_REQUEST';
export const SOLUTIONS_ME_SUCCESS = 'SOLUTIONS_ME_SUCCESS';
export const SOLUTIONS_ME_ERROR = 'SOLUTIONS_ME_ERROR';

export const SOLUTIONS_LATEST_REQUEST = 'SOLUTIONS_LATEST_REQUEST';
export const SOLUTIONS_LATEST_SUCCESS = 'SOLUTIONS_LATEST_SUCCESS';
export const SOLUTIONS_LATEST_ERROR = 'SOLUTIONS_LATEST_ERROR';

const block = {
  loading: true,
  success: false,
  error: null,
};

const initialState = {
  solutions: [],
  solutionsMe: [],
  solutionsLatest: [],
  getSolutionsMe: { ...block },
  getSolutionsLatest: { ...block },
  getSolutions: { ...block, loading: true },
};

export const SolutionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SOLUTIONS_REQUEST:
      return {
        ...state,
        getSolutions: { ...state.getSolutions, loading: true },
      };
    case SOLUTIONS_SUCCESS:
      return {
        ...state,
        getSolutions: {
          ...state.getSolutions,
          loading: false,
          success: true,
          error: null,
        },
        solutions: action.list.results,
      };
    case SOLUTIONS_ERROR:
      return {
        ...state,
        getSolutions: {
          ...state.getSolutions,
          loading: false,
          error: action.error,
        },
      };
    case SOLUTIONS_ME_REQUEST:
      return {
        ...state,
        getSolutionsMe: { ...state.getSolutionsMe, loading: true },
      };
    case SOLUTIONS_ME_SUCCESS:
      return {
        ...state,
        getSolutionsMe: {
          ...state.getSolutionsMe,
          loading: false,
          success: true,
          error: null,
        },
        solutionsMe: action.list,
      };
    case SOLUTIONS_ME_ERROR:
      return {
        ...state,
        getSolutionsMe: {
          ...state.getSolutionsMe,
          loading: false,
          error: action.error,
        },
      };
    case SOLUTIONS_LATEST_REQUEST:
      return {
        ...state,
        getSolutionsLatest: { ...state.getSolutionsLatest, loading: true },
      };
    case SOLUTIONS_LATEST_SUCCESS:
      return {
        ...state,
        getSolutionsLatest: {
          ...state.getSolutionsLatest,
          loading: false,
          success: true,
          error: null,
        },
        solutionsLatest: action.list,
      };
    case SOLUTIONS_LATEST_ERROR:
      return {
        ...state,
        getSolutionsLatest: {
          ...state.getSolutionsLatest,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};
